import React from "react";
import { AlertTriangle, Trash2, X } from "lucide-react";

export default function ConfirmDeleteModal({
  isOpen,
  title = "Delete Item",
  description = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4 animate-in fade-in duration-200">
      <div className="relative w-full max-w-md">
        <div className="absolute -inset-1 bg-red-500/20 rounded-3xl blur-2xl opacity-60 pointer-events-none" />

        <div className="relative bg-gray-900 border border-red-500/40 rounded-3xl shadow-2xl p-6 sm:p-7 transform animate-in fade-in zoom-in duration-200">
          <button
            type="button"
            onClick={loading ? undefined : onCancel}
            className="absolute top-4 right-4 p-2 rounded-full bg-gray-800/80 hover:bg-gray-700 text-gray-300 hover:text-white transition-all border border-gray-700/80 disabled:opacity-60"
            disabled={loading}
          >
            <X size={18} />
          </button>

          <div className="flex flex-col items-center text-center gap-4">
            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-red-500/10 border border-red-500/40 flex items-center justify-center text-red-400 shadow-lg shadow-red-500/20">
                <Trash2 size={28} className="animate-pulse" />
              </div>
              <div className="absolute -bottom-2 -right-2 w-7 h-7 rounded-full bg-amber-500/90 flex items-center justify-center text-black shadow-md shadow-amber-500/60">
                <AlertTriangle size={16} />
              </div>
            </div>

            <div className="space-y-1">
              <h3 className="text-lg sm:text-xl font-semibold text-white tracking-tight">
                {title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">
                {description}
              </p>
            </div>

            <div className="mt-4 w-full flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={loading ? undefined : onCancel}
                className="flex-1 py-2.5 px-4 rounded-xl border border-gray-700 bg-gray-800/80 text-sm font-semibold text-gray-200 hover:bg-gray-700 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                disabled={loading}
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                onClick={onConfirm}
                className="flex-1 py-2.5 px-4 rounded-xl bg-red-600 hover:bg-red-500 text-sm font-semibold text-white shadow-[0_12px_30px_-12px_rgba(239,68,68,0.8)] transition-all active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                disabled={loading}
              >
                {loading && (
                  <span className="h-4 w-4 rounded-full border-2 border-white/40 border-t-transparent animate-spin" />
                )}
                <span>{confirmLabel}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

